import { Box, Typography, useTheme } from '@mui/material';

export const CohortCharacteristicsTabularCategory = ({ category }: { category: string }) => {
  const theme = useTheme();

  return (
    <Box sx={{ px: 4, py: 3 }}>
      <Typography
        variant="body2"
        fontWeight="500"
        sx={{ py: 1 }}
        color={theme.palette.text.primary}
      >
        {category}
      </Typography>
    </Box>
  );
};

export default CohortCharacteristicsTabularCategory;
